import { FC } from 'react';
import styles from './Contact.module.css';
import { useTranslation } from 'react-i18next';

interface ContactProps { }

const Contact: FC<ContactProps> = () => {

  const { t } = useTranslation();

  return (
    <div className={styles.Contact}>
      <div className='pb-4 border rounded-5 p-4 w-100 contrasting-bg' style={{ minHeight: 'calc(100vh - 389.56px)' }}>
        <h2 className='text-center mb-4' style={{ color: '#086972' }}><strong>{t('CONTACT US')}</strong></h2>
        <div className='d-flex justify-content-center align-items-center'></div>
        <p>
          <strong>OMAX Consulting AS</strong><p />
          <p>Tyholtveien 69 D, 7052 Trondheim, {t("Norway")}</p>
          <a href="mailto:post@omaxconsulting.no">post@omaxconsulting.no</a>
        </p>
      </div>
    </div>
  );
}

export default Contact;
